export const getMimeType = (url: string): string => {
  let pathname = url;
  try {
    pathname = new URL(url).pathname;
  } catch {}
  const extension = pathname.split('.').pop()?.toLowerCase();
  const mimeTypes: Record<string, string> = {
    pdf: 'application/pdf',
    jpg: 'image/jpg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    webp: 'image/webp',
  };
  return mimeTypes[extension || ''] || 'application/octet-stream';
};

export const getFileName = (url: string): string => {
  try {
    const { pathname } = new URL(url);
    const fileName = pathname.split('/').pop() || '';
    return fileName || `file_${Date.now()}`;
  } catch {
    return `file_${Date.now()}`;
  }
};

export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result as string;
      const base64Data = base64.split(',')[1];
      resolve(base64Data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
